/**
 * Builds a DataGrid row id that is safe to embed in a CSS attribute selector.
 *
 * MUI resolves rows through `querySelector('.MuiDataGrid-row[data-id="…"]')`, so a row
 * id carrying a CR/LF or a quote — which WaWi article descriptions do, e.g.
 * `Brioche Hamburger\rohne Sesam` — produces an invalid selector and throws on every
 * document click (WA-3609). Ids stay unique because the leading numeric part
 * (article/order id) is preserved untouched.
 */
export const safeRowId = (...parts: unknown[]): string =>
  parts
    .map((part) => `${part ?? ''}`)
    .join('_')
    .replace(/[\r\n\t]+/g, ' ')
    .replace(/["'\\]/g, '')
    .trim();
